import { TFunction } from 'i18next';

export const makeBuhColumns = (t: TFunction, stringType: string) =>
  Array.from({ length: 6 }, (_, index) => ({
    headerName: t(`employeeBonuses.buh${index + 1}Display`),
    field: `buh${index + 1}Display`,
    type: stringType
  }));
